import { Route } from 'react-router-dom';

import RouteProtection from './RouteProtection';
import { routes, RouteModel } from './routes';

const calculateRoutes = (routes: RouteModel[]) =>
  routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={<RouteProtection restrictedTo={route.restrictedTo}>{route.element}</RouteProtection>}
    >
      {route.children ? calculateRoutes(route.children) : null}
    </Route>
  ));

const calculatedRoutes = () => calculateRoutes(routes);

export default calculatedRoutes;
